import { getTagValue, getAttrValue, getTagAttrValue, formatDateMY, formatPhone, trim, getEleArray } from 'helpers/Helpers';
import React from 'react'

export default function Tradelines({trades}) {
	//console.log("lines: ", typeof lines, lines.length, Object.keys(lines).length, lines);
	return (
		<div className='w-full flex flex-col'>
			<div className='header-bar'>
				<div className='header-text'>Tradelines</div>
			</div>
			<TradelineHeader />
			<div className='text-2xl'>
			{
				trades.map((t, i) => {
					return (
						<Tradeline key={i} t={t} ix={i} />
					);
				})
			}
			</div>
		</div>
	)
}

function TradelineHeader() {

	return (
		<div className='w-full flex flex-col text-xs font-bold'>
			<div className='w-full flex flex-row border-t-2 border-l-2 border-r-2'>
				<div className='w-[353px] pl-10 border-r-2'>Creditor Name</div>
				<div className='w-[353px] pl-10 border-r-2'>Repositories</div>
				<div className='w-[353px] pl-10'>Creditor Phone</div>
			</div>
			<div className='w-full flex flex-row border-t-2 text-center'>
				<div className='w-[22px] border-l-2 border-b-2'>W</div>
				<div className='w-[187.5px] px-2 border-l-2 border-b-2'>Account Number</div>
				<div className='w-[77px] border-l-2 border-b-2'>Date Rptd</div>
				<div className='w-[77px] border-l-2 border-b-2'>Date Open</div>
				<div className='w-[109.5px] border-l-2 border-b-2'>HiCr/CrLim</div>
				<div className='w-[109.5px] border-l-2 border-b-2'>Balance</div>
				<div className='w-[76.8px] border-l-2 border-b-2'>Terms</div>
				<div className='w-[87.75px] border-l-2 border-b-2'>Past Due</div>
				<div className='w-[65.7px] border-l-2 border-b-2'>Last Actv</div>
				<div className='w-[43.8px] border-l-2 border-b-2'>MR</div>
				<div className='w-[32.8px] border-l-2 border-b-2'>30</div>
				<div className='w-[32.8px] border-l-2 border-b-2'>60</div>
				<div className='w-[32.8px] border-l-2 border-b-2'>90</div>
				<div className='w-[32.8px] border-l-2 border-b-2'>90+</div>
				<div className='w-[72px] border-l-2 border-b-2 border-r-2'>Rating</div>
			</div>
			{/* <div className='courier text-[18.3px] ml-[3px] w-min'>
				<div className='w-min courier'>123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456</div>
				<div className='w-min courier'>WWWWWWWWW0WWWWWWWWW0WWWWWWWWW0WWWWWWWWW0WWWWWWWWW0WWWWWWWWW0WWWWWWWWW0WWWWWWWWW0WWWWWWWWW0WWWWWW</div>
			</div> */}
		</div>
	)
}

function Tradeline({t, ix}) {
	//console.log(t);
	var ct = t;
	var tid = getAttrValue(ct, "CreditLiabilityID");
	//console.log("ct: ", ct);
	var reps = getEleArray(t, "UNMERGED_LIABILITY");
	//console.log("reps: ", typeof reps, reps);
	//console.log(getAttrValue(t, "SEQUENCEID"));
	return (
		<div>
			<div className={(ix%2)===0 ? "bg-slate-200" : ''}>
				<ShowTradeline ct={ct} id={tid} />
				{ 
					reps.map((rep, i) => {
						return (<CreditComments key={i} rep={rep} />)
					})
				}
			</div>
			<div>
				{ reps.length !== undefined &&
						<ShowReps reps={reps} id={tid} />
				}
			</div>
			{/* <div className='h-4'></div> */}
		</div>
	)
}

function ShowReps({reps, id}) {

	var rid = 'rep-' + id;

	return (
		<div id={rid} className='bg-slate-700 text-white hidden'>
			{
			reps.map((rep, i) => {
				return (
					<div key={i} className={(i%2)===0 ? "bg-slate-700" : "bg-slate-600"}>
						<ShowTradeline ct={rep} id={rid} />
						<CreditComments key={i} rep={rep} />
					</div>
					)
				})
			}	
		</div>
	)
}

function ShowTradeline({ct, id}) {
	//console.log("ct: ", ct);

	var cfid = getAttrValue(ct, "CreditFileID");
	var aot = getAttrValue(ct, "_AccountOwnershipType");
	var nfu = getAttrValue(ct, "BorrowerID");
	//var owner = getAttrValue(ct, "AccountOwnershipType");
	var accountType = getAttrValue(ct, "_AccountType");
	var ratingType = getTagAttrValue(ct, "_CURRENT_RATING", "_Code");

	var termsMo = getAttrValue(ct, "_TermsMonthsCount");
	//console.log("termsMo: ", termsMo);

	if (!termsMo) termsMo = '';
	else if (termsMo.length > 0) termsMo += 'X';
	var termsPmt = getAttrValue(ct, "_MonthlyPaymentAmount");
	// var pd120 = getAttrValue(ct, "Late120DaysCount");
	// var pd150 = getAttrValue(ct, "Late150DaysCount");
	// var pd180 = getAttrValue(ct, "Late180DaysCount");
	// var ninetyPlus = Number(pd120) + Number(pd150) + Number(pd180);
	var ninetyPlus = '';
	var pp = getTagAttrValue(ct, "_PAYMENT_PATTERN", "_Data");
	var ppsd = formatDateMY(getTagAttrValue(ct,  "_PAYMENT_PATTERN", "_StartDate"));
	var at = '';
	switch (accountType)
	{
		case 'Undesignated':
			at = 'U';
			break;
		case 'Installment':
			at = 'I';
			break;
		case 'Revolving':
			at = 'R';
			break;
		case 'OneMonth':
			at = 'O';
			break;
		case 'Mortgage':
			at = 'M';
			break;
		case 'CreditLine':
			at = 'C';
			break;
		default:
			at = 'U';
			break;
	}
	var rating = at + '-' + ratingType;

	var whose = 'U';
	if (aot === 'JointContractualLiability') whose = 'P';
	else if (nfu === 'PRIMARY_SUBJECT') whose = 'B';
	else if (nfu === 'SECONDARY_SUBJECT') whose = 'C';
	//console.log(ct.LastActivityDate);
	//console.log("reps: ", typeof reps, Object.keys(reps).length, reps);

	function showReps(id) {
		var rid = "rep-" + id;
		//console.log("showReps", rid);
		var ele = document.getElementById(rid);
		//console.log(ele.style.display);
		if (ele.style.display === "block") {
				ele.style.display = "none";
		} else {
				ele.style.display = "block"
		}
	}

	return (
		<div id={id} className='pl-[3px] value'>
			<div className="w-full flex flex-row">
				<div className='w-[22px] pt-1'>
					{ !id.startsWith('rep') &&
						<img 
							src={require('../../images/info-24.png')} 
							width={20}
							alt='Show Repository Tradelines' 
							onClick={() => showReps(id)}
						/>
					}
				</div>
				<div className='w-[345px]'>{getTagAttrValue(ct, "_CREDITOR", "_Name")}</div>
				<div className='w-[215.5px]'>{cfid}</div>
				<div className='w-[76.65px] text-end'>{termsMo}</div>
				<div className='w-[52.85px]'></div>
				<div className='w-[345px]'>{creditorPhone(getAttrValue(ct, "CREDITOR"))}</div>
			</div>
			<div className="w-full flex flex-row">
				<div className='w-[22px]'>{whose}</div>
				<div className='w-[175.2px]'>{trim(getAttrValue(ct, "_AccountIdentifier"), 15)}</div>
				<div className='w-[77px]'>{formatDateMY(getAttrValue(ct, "_AccountStatusDate"))}</div>
				<div className='w-[77px]'>{formatDateMY(getAttrValue(ct, "_AccountOpenedDate"))}</div>
				<div className='w-[109.5px] text-end'>{getAttrValue(ct, "_HighCreditAmount")}</div>
				<div className='w-[109.5px] text-end'>{getAttrValue(ct, "_UnpaidBalanceAmount")}</div>
				<div className='w-[76.8px] text-end'>{termsPmt}</div>
				<div className='w-[87.75px] text-end'>{getAttrValue(ct, "_PastDueAmount")}</div>
				<div className='w-[65.7px] text-end'>{formatDateMY(getAttrValue(ct, "_LastActivityDate"))}</div>
				<div className='w-[43.8px] text-end'>{getAttrValue(ct, "_MonthsReviewedCount")}</div>
				<div className='w-[32.8px] text-end'>{getTagAttrValue(ct, "_LATE_COUNT", "_30Days")}</div>
				<div className='w-[32.8px] text-end'>{getTagAttrValue(ct, "_LATE_COUNT", "_60Days")}</div>
				<div className='w-[32.8px] text-end'>{getTagAttrValue(ct, "_LATE_COUNT", "_90Days")}</div>
				<div className='w-[32.8px] text-end'>{ninetyPlus}</div>
				<div className='w-[54.75px] text-end'>{rating}</div>
			</div>
			<div className="w-full flex flex-row">
				<div className='w-[77px] text-end'>{ppsd}</div>
				<div className='w-[900px] pl-3'>{pp}</div>
			</div>
		</div>
	)

}

function CreditComments({rep}) {
	let cmts = getEleArray(rep,"CREDITCOMMENT");
	//console.log("cmts: ", cmts);
	if (cmts === null) {
		//console.log("undefined")
		return;
	}

	return (
		<div className='pl-[3px] courier text-[18.3px]'>
			<div>
				{
					cmts.map((comment, i) => {
						return(<CreditComment key={i} comment={comment} />)
					})
				}
			</div>
		</div>
	)
}

function CreditComment({comment}) {
	var c = getTagValue(comment, "Comment");
	//console.log("comment: ", comment, "/",c,"/");
	if (c === '') return;
	return (
			<div className='pl-14'>{c}</div>
	)
}

function creditorPhone(creditor) {
	//console.log("creditor: ", creditor);
	if (typeof creditor !== 'object') return '';
	var contact = creditor.CONTACT;
	if (!contact) return '';
	var point = contact[0].CONTACTPOINT;
	//console.log(point);
	if (point === undefined) return '';
	var phone = getTagValue(point, "ContactPointValue");
	if (phone === 'BYMAILONLY') return '';
	return formatPhone(phone);
}

